// Map work department char (afd) to the legacy tag value used in
// `department:<value>` tags. Source: legacy frontend/src/common/logic/charToDepartment.ts.
// Will be removed once label-based tagging replaces this format post-migration.
const DEPARTMENT_CHAR_TO_TAG_VALUE: Record<string, string> = {
  V: 'climate',
  E: 'electrical',
  K: 'greenhouse',
  W: 'irrigation',
  S: 'service',
  C: 'climate-cells',
};

export function departmentCharToTagValue(char?: string | null): string | null {
  if (!char) return null;
  return DEPARTMENT_CHAR_TO_TAG_VALUE[char] ?? null;
}
